// src/components/HelpButton/index.tsx
import { FC, useState } from 'react';
import { useLocation } from 'react-router-dom';
import HelpModal from '@/components/HelpModal';
import { trackEvent } from '@/utils/analytics';
import { EVENTS } from '@/utils/analyticsEvents';
import styles from './index.module.scss';

const HelpButton: FC = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const location = useLocation();

  const handleClick = () => {
    trackEvent(EVENTS.HELP_WIDGET_OPENED, { page: location.pathname });
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <button className={styles.helpButton} onClick={handleClick} aria-label="Help" title="Help">
        <svg className={styles.icon} aria-hidden="true">
          <use xlinkHref="#icon-help"></use>
        </svg>
      </button>
      <HelpModal open={modalOpen} onClose={handleCloseModal} />
    </>
  );
};

export default HelpButton;
